// src/components/Login.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { database, ref, get, child } from '../firebase';
import './styles.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      alert('Please fill in both email and password.');
      return;
    }

    try {
      const dbRef = ref(database);
      const snapshot = await get(child(dbRef, 'users'));

      if (snapshot.exists()) {
        let matched = false;

        snapshot.forEach(userNode => {
          const userData = userNode.val();
          if (userData.email === email && userData.password === password) {
            matched = true;
          }
        });

        if (matched) {
          navigate('/dashboard'); // ✅ Navigate to dashboard
        } else {
          alert('Email or password is incorrect.');
        }

      } else {
        alert('No users found in the database.');
      }
    } catch (error) {
      console.error('Error during login:', error.message);
      alert('Login failed. Please try again.');
    }
  };

  return (
    <div className="login-signup-bg">
      <div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwhhDo0NZ9iWcEgTHVMjJWGnWIOunvh-a0Pg&s"
            alt="Logo"
            style={{ height: 50, width: 50, margin: '0 auto' }}
          />
          <h2>Log In</h2>

          <div className="input-group">
            <i className="fas fa-envelope"></i>
            <input
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <i className="fas fa-key"></i>
            <input
              type="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="login-button">Log In</button>

          <p className="signup-text">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
